import React, { useEffect, useState } from "react";
import { Select, Form } from "antd";
import { store } from '@root/store';
import { getInstituteSubjectList } from '@root/common/service';

export interface SubjectProps {
	id?: number,
	name?: string,
	subjectId?: number,
	subjectName?: string
}

export interface SubjectSelectProps {
	label?: string | boolean,
	name?: string,
	styles?: React.CSSProperties,
	showAll?: boolean,
	placeholder?: string,
	rules?: any,
	// 是否仅展示与机构相关的学科
	orgainizeSelect?: boolean,
	onSelect?: (value: number) => void;
}

const { Option } = Select;
const SubjectSelect: React.FC<SubjectSelectProps> = (props) => {
	const { label, name, styles, showAll, placeholder, rules, orgainizeSelect, onSelect } = props;
	const [subjectList, setList] = useState<SubjectProps []>([]);

	useEffect(() => {
		if (orgainizeSelect) {
			getInstituteSubjectList({}).then(res => {
				setList(res.data)
			})
		} else {
			setList(store.getState().directionaries.subjectData)
		}
	}, [])

	const onSelectHandle = (value: number) => {
		onSelect && onSelect(value)
	}
	
	return (
		<Form.Item 
			label={label} 
			name={name} 
			style={{...styles}}
			rules={rules}
		>
			<Select placeholder={placeholder} onSelect={onSelectHandle}>
				{ showAll && <Option value="all">全部</Option> }
				{
					subjectList.map((subject, index) => {
						return (
							<Option key={index} value={subject.id || subject.subjectId}>
								{subject.name || subject.subjectName}
							</Option>
						)
					})
				}
			</Select>
		</Form.Item>
  )
}

SubjectSelect.defaultProps = {
	label: '学科',
	name: 'subject',
	showAll: false,
	placeholder: '请选择所在学科'
}

export default SubjectSelect;